<template>
  <v-icon-btn size="small" icon="mdi-content-copy" @click="copy(content)" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useCopyToClipboard } from '~/composables/common/useCopyToClipboard'

export default defineComponent({
  name: 'ContentCopy',
  props: {
    content: {
      type: null,
      required: true,
    },
  },
  setup() {
    const { copy } = useCopyToClipboard()
    return {
      copy,
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
})
</script>

<style scoped lang="scss"></style>
